// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"43cc06fc","150":"7f7f7703","186":"90b3c5c0","481":"53832e85","543":"15b9f0f9","617":"1115d8db","736":"355103b9","787":"f309dd56","970":"fa776323"}[chunkId] + ".chunk.js";
};